export const buttonClasses = "text-white font-bold rounded capitalize";
export const primaryButtonClasses = `${buttonClasses} bg-blue-500 hover:bg-blue-700 py-6 px-6`;
export const linkButtonClasses = `${buttonClasses} bg-blue-500 hover:bg-blue-700 py-6 px-6`;
export const homeButtonClasses = `${buttonClasses} bg-gray-500 hover:bg-gray-700 py-6 px-6`;
export const cardClasses =
  "flex min-h-40 justify-center items-center m-1 text-2xl rounded-md text-white font-semibold p-6";

export const cardStatus = {
  info: "bg-green-400",
  error: "bg-red-500",
  neutral: "bg-gray-400",
};
